import * as React from "react";
const SvgBooked = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.667 3.011A6 6 0 0 1 8 2a6.017 6.017 0 0 1 6 6 6 6 0 1 1-9.333-4.989m6.591 2.598c.18.181.18.475 0 .656l-4.235 4.262-2.281-2.295a.466.466 0 0 1 0-.656.46.46 0 0 1 .652 0l1.629 1.64 3.583-3.607a.46.46 0 0 1 .652 0",
    clipRule: "evenodd"
  }
));
export default SvgBooked;
